import { FileText, BadgeCheck, Clock } from "lucide-react";
import type { Product } from "@/types";
import { Container } from "@/components/atoms";

const isRealUrl = (u: string | undefined): u is string =>
  typeof u === "string" && /^https?:\/\//i.test(u.trim());

export function LabResults({ product }: { product: Product }) {
  return (
    <Container className="py-8">
      <div className="flex flex-col items-center justify-between gap-4 rounded-card bg-leaf-green/10 p-6 sm:flex-row">
        <div className="flex items-center gap-4">
          <div className="flex h-16 w-16 shrink-0 flex-col items-center justify-center rounded-full bg-leaf-green-ink text-white">
            <span className="font-condensed text-base font-bold leading-none">
              99.5%
            </span>
            <span className="text-[8px] uppercase">accuracy</span>
          </div>
          <div>
            <h3 className="font-condensed text-lg font-bold text-night-blue">
              Lab verified
            </h3>
            <p className="flex items-center gap-1 text-sm text-night-blue/70">
              <BadgeCheck size={14} className="text-leaf-green-ink" />{" "}
              Third-party tested by CBD Informative
            </p>
          </div>
        </div>
        {/*
          DRB-66 — branch on a REAL http(s) URL, not merely a truthy string. Live Firestore held
          the literal "#coa" on 9 of 10 products, including BOTH active ones, so every product page
          rendered a "View Certificate of Analysis" link that went nowhere. On a CBD site that is a
          trust claim, and a dead one is worse than an honest "pending": it says lab results exist
          and are viewable. The placeholders have been cleared, and this guard means a non-URL can
          never render as a working link again.
        */}
        {isRealUrl(product.labCertificateUrl) ? (
          <a
            href={product.labCertificateUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-pill border-2 border-night-blue/15 px-5 py-2 text-sm font-bold text-night-blue hover:border-leaf-green hover:text-leaf-green-ink"
          >
            <FileText size={16} /> View Certificate of Analysis
          </a>
        ) : (
          <span className="inline-flex items-center gap-2 rounded-pill border-2 border-night-blue/10 px-5 py-2 text-sm text-night-blue/70">
            <Clock size={16} /> Lab results pending
          </span>
        )}
      </div>
    </Container>
  );
}
